import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { Button } from '@/components/ui/button';
import { getFlatfinder } from './api';
import { FlatfinderEditor } from './flatfinder-editor';

export function FlatfinderWorkspace({ projectId }: { projectId: string }) {
  const { t } = useTranslation();
  const query = useQuery({
    queryKey: ['flatfinder', projectId],
    queryFn: () => getFlatfinder(projectId),
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (query.error) toast.error(query.error.message);
  }, [query.error]);

  if (query.isPending) return <p className="p-6">{t('flatfinderWorkspaceLoading')}</p>;
  if (query.isError) {
    return (
      <Button variant="outline" onClick={() => void query.refetch()}>
        {t('flatfinderWorkspaceRetry')}
      </Button>
    );
  }

  return <FlatfinderEditor key={projectId} initial={query.data} />;
}
